<template>
  <div class="main-dask">
    <div v-if="Object.keys(sensorList).length != 1">
      <MyCollapse v-for="company, companyName in filteredSensorList" :nameCollapse="company.show_name" :key="companyName">
        <div class="widget-area">
          <p class="rows-name middle-high">Датчики</p>
          <div class="widget-row-place">
            <SensorWidget v-for="item in company.sensors" :key="item.id_sensor"
              :name="item.name"
              :mac="item.MAC"
              :temperature="item.temperature"
              :vibration="item.vibrations"
              :total_time="item.total_time"
              :month_time="item.month_time"
              :week_time="item.week_time"
              :day_time="item.day_time"
              :rpm="item.rpm"
              :message="message"
              :power="item.power"
              :id="item.id_sensor"
              :addition_params="item.addition_params"
              :isMotorLifeGone="checkMotorLife(item.motor_life_offset, item.motor_life_start, item.total_time)"
              :sensor="true"
              :date_update_param="checkStatus(item.date_update_param)"
              :isSensorImage="item.sensor_image"
              :isPlaceImage="item.place_image"
              @open-graf="openGraphWindow"
              :levelVibrationsCode="item.level_vibrations_code"
              @open-param="openParamWindow" />
          </div>

        </div>
        <div class="widget-area" v-if="company.counters.length != 0">
          <p class="rows-name middle-high">Счетчики</p>
          <div class="widget-row-place">
            <CounterWidget v-for="item in company.counters" :key="item.id_counter" :name="item.name"
              :address="item.address" :voltage="item.voltage" :frequency="item.frequency" :cosFi="item.cos_fi"
              :current="item.current" :energy="item.energy_total" :energyDay="item.energy_day" :id="item.id_counter"
              @open-graf="openGraphWindow" @open-param="openParamWindow" />
          </div>
        </div>

      </MyCollapse>
    </div>
    <div class="solo-company" v-else v-for="company, companyName in sensorList" :key="companyName">
      <div class="widget-area">
        <p class="rows-name middle-high">Датчики</p>
        <div class="widget-row-place">
          <SensorWidget v-for="item in company.sensors" :key="item.id_sensor"
            :name="item.name"
            :mac="item.MAC"
            :temperature="item.temperature"
            :vibration="item.vibrations"
            :total_time="item.total_time"
            :month_time="item.month_time"
            :week_time="item.week_time"
            :day_time="item.day_time"
            :rpm="item.rpm"
            :power="item.power"
            :id="item.id_sensor"
            :message="message"
            :addition_params="item.addition_params"
            :isMotorLifeGone="checkMotorLife(item.motor_life_offset, item.motor_life_start, item.total_time)"
            :sensor="true"
            :date_update_param="checkStatus(item.date_update_param)"
            :isSensorImage="item.sensor_image"
            :isPlaceImage="item.place_image"
            @open-graf="openGraphWindow"
            :levelVibrationsCode="item.level_vibrations_code"
            @open-param="openParamWindow"
          />
        </div>

      </div>
      <div class="widget-area" v-if="company.counters.length != 0">
        <p class="rows-name middle-high">Счетчики</p>
        <div class="widget-row-place">
          <CounterWidget v-for="item in company.counters" :key="item.id_counter" :name="item.name"
            :address="item.address" :voltage="item.voltage" :frequency="item.frequency" :cosFi="item.cos_fi"
            :current="item.current" :energy="item.energy_total" :energyDay="item.energy_day" :id="item.id_counter"
            @open-graf="openGraphWindow" @open-param="openParamWindow" />
        </div>
      </div>
    </div>
    <Transition name="fade" mode="out-in">
      <WindowGraph
        v-if="switcherGraph"
        @closeWindow="closeGraphWindow"
        :name="graphWindow.name"
        :id="graphWindow.id"
        :listElements="graphWindow.listElements"
        :typeWindow="graphWindow.typeWindow"
      />
    </Transition>
    <Transition name="fade" mode="out-in">
      <WindowParam 
        v-if="switcherParam"
        :addition="true"
        @closeWindow="closeParamWindow"
        :id="paramWindow.id"
        :mac="paramWindow.mac"
        :power="paramWindow.power"
        :rpm="paramWindow.rpm"
        :motor_life_offset="paramWindow.motor_life_offset"
        :motor_life_start="paramWindow.motor_life_start"
        :name_element="paramWindow.name"
        :date="paramWindow.date"
        :company_id="paramWindow.company"
        :addition_params="paramWindow.addition_params"
        :typeWindow="paramWindow.typeWindow"
        :groupSensor="paramWindow.groupSensor"
        :isNewGroup="paramWindow.isNewGroup"
        :showSensorImage="paramWindow.sensor_image"
        :showPlaceImage="paramWindow.place_image"
        :total_time="paramWindow.total_time"
        :custom_level_vibrations="paramWindow.custom_level_vibrations"
      />
    </Transition>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'

import SensorWidget from '@/pages/dashboard/SensorWidget.vue'
import CounterWidget from '@/pages/dashboard/CounterWidget.vue'
import WindowGraph from '@/pages/dashboard/WindowGraph.vue'
import WindowParam from '@/pages/dashboard/WindowParam.vue'
import MyCollapse from '@/pages/dashboard/MyCollapse.vue'

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters('user', {
      userOptions: 'getUserOptions',
    }),
    ...mapGetters('sensors', {
      sensorList: 'getSensorList',
    }),
    filteredSensorList() {
      return Object.entries(this.sensorList).reduce((acc, [key, value]) => {
        const sensorsEmpty = !value.sensors || value.sensors.length === 0
        const countersEmpty = !value.counters || value.counters.length === 0

        if (!(sensorsEmpty && countersEmpty)) {
          acc[key] = value
        }
        return acc
      }, {})
    }
  },
  data() {
    return {
      switcherGraph: false,
      switcherParam: false,
      message: null,
      paramWindow: {
      },
      graphWindow: {
      },
      flagStopTimeout: false,
      timeoutID: null,
      currentTime: Date.now(),
    }
  },
  components: {
    SensorWidget,
    CounterWidget,
    WindowGraph,
    WindowParam,
    MyCollapse
  },
  methods: {
    ...mapMutations('user', {
      setLogin: 'setLogin'
    }),
    ...mapActions('user', {
      postLogout: 'postLogout',
    }),
    ...mapActions('sensors', {
      getSensorLastData: 'getSensorLastData',
    }),
    logOutClick() {
      this.postLogout()
    },
    checkMotorLife(motor_life_offset, motor_life_start, total_time) {
      if (!motor_life_offset || !motor_life_start || !total_time) {
        return false
      } else {
        return (motor_life_offset+motor_life_start) < total_time
      }
    },
    motoHandler() {
      const moto = this.paramWindow.motoResourse - Math.floor(Date.now() / 1000)
      if (typeof this.paramWindow.motoResourse === 'object' || moto >= 0) {
        return
      }
    },
    openGraphWindow(id, name, typeWindow) {
      this.switcherGraph = true
      let listElemForGraph = [];
      for (const [key, value] of Object.entries(this.sensorList)) {
        if (typeWindow == 'sensor' && null != value.sensors.find(el => el.id_sensor == id)) {
          listElemForGraph = value.sensors;
        }
        if (typeWindow == 'counter' && null != value.counters.find(el => el.id_counter == id)) {
          listElemForGraph = value.counters;
        }
      }
      this.graphWindow = {
        id: id,
        name: name,
        typeWindow: typeWindow,
        listElements: listElemForGraph
      }
    },
    closeGraphWindow() {
      this.switcherGraph = false
      this.graphWindow = {}
    },
    openParamWindow(id, name, typeWindow) {
      const groups = { 0: 'Без группы', 1: 'Группа 1', 2: 'Группа 2', 3: 'Группа 3' }

      if (typeWindow == 'sensor') {
        for (const property in this.sensorList) {
          this.sensorList[property].sensors.find(el => {
            if (el.id_sensor == id && el.name == name) {
              this.paramWindow.typeWindow = typeWindow
              this.paramWindow.id = el.id_sensor
              this.paramWindow.mac = el.MAC
              this.paramWindow.power = el.power
              this.paramWindow.rpm = el.rpm
              this.paramWindow.motor_life_offset = el.motor_life_offset
              this.paramWindow.motor_life_start = el.motor_life_start
              this.paramWindow.name = el.name
              this.paramWindow.date = el.created_date
              this.paramWindow.company = el.company_id ? el.company_id : 0
              this.paramWindow.addition_params = el.addition_params
              this.paramWindow.groupSensor = groups[el.group]
              this.paramWindow.isNewGroup = el.is_new
              this.paramWindow.custom_level_vibrations = el.custom_level_vibrations
              this.paramWindow.place_image = el.place_image
              this.paramWindow.sensor_image = el.sensor_image
              this.paramWindow.total_time = el.total_time
            }
          })
        }
        this.switcherParam = true

      } else if (typeWindow == 'counter') {
        for (const property in this.sensorList) {
          this.sensorList[property].counters.find(el => {
            if (el.id_counter == id && el.name == name) {
              this.paramWindow.typeWindow = typeWindow
              this.paramWindow.id = el.id_counter
              this.paramWindow.mac = el.address
              this.paramWindow.name = el.name
              this.paramWindow.date = el.created_date
              this.paramWindow.company = el.company_id ? el.company_id : 0
              this.paramWindow.addition_params = []
            }
          })
        }

        this.switcherParam = true
        //console.log("switcherParam после открытия:", this.switcherParam)
      } else {
        alert("wrong property")
      }

    },
    closeParamWindow() {
      this.switcherParam = false

      //console.log(this.switcherParam)
      this.paramWindow = {}

    },
    getDiscriptionsOfStatus(findArray, code) {
      console.log(findArray, code)
      if (findArray) {
        let description = 'Неопределенный статус';
        findArray.find(el => {
          if (el.code == code) {
            description = el.description
          }
        })
        return description
      } else {
        return ''
      }
    },
    updateData() {
      try {
        this.getSensorLastData();
        if (!this.flagStopTimeout) {
          this.timeoutID = setTimeout(this.updateData, 10000)
        }
      } catch (error) {
        this.$router.push('/');
      }
    },
    checkStatus(date) {
      const d = new Date(date);
      const diffMs = this.currentTime - d.getTime();
      return diffMs >= 5 * 60 * 1000;
    }
  },
  created() {
    this.flagStopTimeout = false
    this.getSensorLastData();
    this.timeoutID = setTimeout(this.updateData, 10000)
  },
  beforeUnmount() {
    this.flagStopTimeout = true
    clearTimeout(this.timeoutID)
  }
}

</script>

<style noscoped lang="scss">
.solo-company {
  overflow: hidden;
  transition: all .2s ease;
  padding: 24px 30px;
  // display: grid;
  // grid-template-columns: repeat(4, 1fr);
  // gap: 10px;
}

.widget-row-place {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.rows-name {
  padding: 10px 20px;
  color: var(--gray-dark-color);
}

.widget-area {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 3px;
  margin: 5px 0;
}

// .high-board{
//     width: 100vw;
//     background: #3F51B5;
//     height: 7vh;
//     box-shadow: 3px 13px 8px 0px rgba(34, 60, 80, 0.2);
//     display: flex;
//     align-items: center;

//     .logout{
//         cursor: pointer;
//         margin: 0px 1vw;
//         height: 50%;
//         background: #fff;
//         padding: 4px 10px;
//         border-radius: 4px;
//         i{
//             margin: 0px 6px;
//             color:#3f51b5;
//         }
//     }
// }

.main-dask {
  height: 93vh; //issue: should be 93vh
  // display: flex;
  // align-items: flex-start;
  // justify-content: flex-start;
  // flex-direction: row;
  // flex-wrap: wrap;
  // align-content: flex-start;
  padding: 10px 1vw;
  overflow-y: auto;
}

@media screen and (max-width: 1210px) {
  .widget-row-place {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 810px) {
  .widget-row-place {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
